import SearchInput from 'components/SearchInput';
import {
  StyledAutoCompleteInfo,
  StyledAutoCompleteList,
  StyledAutoCompleteMain
} from './AutoCompleteList.style';
import AutoCompleteListOption from './AutoCompleteListOption';
import SelectAllOption from './SelectAllOption';
import useAutoCompleteList from './useAutoCompleteList';
import { useMemo } from 'react';

const EMPTY_TEXTS = {
  NO_RESULTS_FOUND: 'No results found',
  NO_ITEMS: 'There are no items to display'
};

const AutoCompleteList = ({
  isLoading = false,
  options = [],
  selectedValues = [],
  disabledValues = [],
  onChange,
  withSelectAll = false,
  disabled = false
}) => {
  const { filteredOptions, isEmpty, keyword, setKeyword, onChangeCheckbox } =
    useAutoCompleteList({
      options,
      selectedValues,
      onChange
    });

  const emptyText = useMemo(
    () =>
      isEmpty && keyword.length > 0
        ? EMPTY_TEXTS.NO_RESULTS_FOUND
        : EMPTY_TEXTS.NO_ITEMS,
    [filteredOptions.length]
  );

  return (
    <StyledAutoCompleteList>
      <SearchInput
        value={keyword}
        placeholder='Search...'
        autoFocus
        width='unset'
        height='3.1rem'
        onChange={setKeyword}
        disabled={disabled}
      />

      <StyledAutoCompleteMain>
        {!isLoading && !isEmpty && (
          <>
            {withSelectAll && filteredOptions.length > 1 && (
              <SelectAllOption
                options={filteredOptions}
                selectedValues={selectedValues}
                onChange={onChange}
                disabled={disabled}
              />
            )}
            {filteredOptions.map(option => (
              <AutoCompleteListOption
                key={option.value}
                option={option}
                isChecked={selectedValues.includes(option.value)}
                isDisabled={disabledValues.includes(option.value) || disabled}
                onChange={onChangeCheckbox}
              />
            ))}
          </>
        )}
        {!isLoading && isEmpty && (
          <StyledAutoCompleteInfo>{emptyText}</StyledAutoCompleteInfo>
        )}
        {isLoading && (
          <StyledAutoCompleteInfo>Loading...</StyledAutoCompleteInfo>
        )}
      </StyledAutoCompleteMain>
    </StyledAutoCompleteList>
  );
};

export default AutoCompleteList;
